import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEs from './locales/es/common.json';
import commonEn from './locales/en/common.json';
import tasksEs from './locales/es/tasks.json';
import tasksEn from './locales/en/tasks.json';
import docsEs from './locales/es/docs.json';
import docsEn from './locales/en/docs.json';
import dataindexEs from './locales/es/dataindex.json';
import dataindexEn from './locales/en/dataindex.json';
import calendarEs from './locales/es/calendar.json';
import calendarEn from './locales/en/calendar.json';
import clientEs from './locales/es/client.json';
import clientEn from './locales/en/client.json';
import profileEs from './locales/es/profile.json';
import profileEn from './locales/en/profile.json';
import spacesEs from './locales/es/spaces.json';
import spacesEn from './locales/en/spaces.json';

// i18n (2026-07-12): español por defecto -- el idioma real del usuario (persistido en
// `user_preferences`, backend) se aplica después vía `i18n.changeLanguage()` en
// `UserContext.jsx`, en cuanto el login (o el `currentUser` de localStorage) resuelve. Antes de
// eso -- pantalla de login, primer render -- español es el default correcto para esta base de
// usuarios (colonny.xyz es una app en español).
//
// Un namespace por feature folder (mismo criterio que la arquitectura del backend) en vez de un
// solo diccionario gigante -- cada uno se extrajo con un pase dedicado sobre su propio feature
// (`common`: login + sidebar; `tasks`/`docs`/`dataindex`/`calendar`/`client`: sus respectivos
// módulos). `defaultNS: 'common'` porque es el único namespace que `t()` sin argumento de
// namespace debe resolver por default (el resto se piden explícitos:
// `useTranslation('tasks')`, etc.).
i18n
    .use(initReactI18next)
    .init({
        resources: {
            es: {
                common: commonEs,
                tasks: tasksEs,
                docs: docsEs,
                dataindex: dataindexEs,
                calendar: calendarEs,
                client: clientEs,
                profile: profileEs,
                spaces: spacesEs,
            },
            en: {
                common: commonEn,
                tasks: tasksEn,
                docs: docsEn,
                dataindex: dataindexEn,
                calendar: calendarEn,
                client: clientEn,
                profile: profileEn,
                spaces: spacesEn,
            },
        },
        lng: 'es',
        fallbackLng: 'es',
        defaultNS: 'common',
        ns: ['common', 'tasks', 'docs', 'dataindex', 'calendar', 'client', 'profile', 'spaces'],
        interpolation: { escapeValue: false }, // React ya escapa por sí solo
    });

export default i18n;
